import React from 'react';
import './DrawerToggleButton.css';
import { elakayAutoText } from "../../includes/pageInside/dataElakay";


const DrawerToggleButton = ({ click, isOpen = false, variant = 'light' }) => (
  <button 
    className={`drawer-toggle-btn ${isOpen ? 'open' : ''} ${variant}`}
    onClick={click}
    aria-label={isOpen ? elakayAutoText("h_6c9fc990898478", "Close menu") : elakayAutoText("h_197101e9db29b4", "Open menu")}
    aria-expanded={isOpen}
  >
    <span className="toggle-line line-1" />
    <span className="toggle-line line-2" />
    <span className="toggle-line line-3" />
  </button>
);

export default DrawerToggleButton;